import React from 'react';
import './footer.scss';
import { Link } from 'react-router-dom';
const Footer = () => {
  const currentYear = new Date().getFullYear();
  return (
    <>
           <div className="loginfooter">
          <div className="theme-container">
            <div className="innerloginfooter">
            <img src="/logoblack.svg" alt="logoimg" className="logoimg" />
            <p className="footerpara">©{currentYear} GEMS. All rights reserved</p>
            <Link to="/termsofuse" className="footerpara">Terms of Use</Link>
            </div>
          </div>
        </div>
    </>
  )
}

export default Footer;
